export default "__VITE_ASSET__33c7bb8e__"